
import Dialog from '~/components/common/Dialog.vue'
export default {
  components: {
    Dialog
  },
   props: {
     statementList: {
        type: Array,
        default: () => []
    },
   },
    data() {
        return {
            defaultType: 0,
            isLogShow: false,
            controlType: '',
            statementDataList: [],
            itemObj: null
        }
    },
    created() {
        // this.statementDataList = this.statementList[this.defaultType].items
    },
    mounted() {
        console.log(this.statementList, 'statementList');
        this.initData()
    },
    methods: {
       initData () {
            this.statementList.forEach((el, index) => {
              const tempObj = {
                items: el.items.slice(0, 3),
                isShowMore: el.items.length > 3,
                isUnfold: false
              }
              this.statementDataList.push(tempObj)
            });
           this.controlType = this.statementList[this.defaultType].companyControlType
        },
      companyTabClick(i) {
        this.defaultType = i
        // this.initData()
        this.controlType = this.statementList[this.defaultType].companyControlType
        // this.statementDataList = this.statementList[this.defaultType].items
      },
      moreClick () {
        this.statementDataList[this.defaultType].isUnfold = !this.statementDataList[this.defaultType].isUnfold
        if (!this.statementDataList[this.defaultType].isUnfold) {
          this.statementDataList[this.defaultType].items = this.statementList[this.defaultType].items.slice(0, 3)
        } else {
           this.statementDataList[this.defaultType].items = this.statementList[this.defaultType].items
        }
      },
      controlDalog (item) {
        if (this.$store.state.mobile) {
           this.itemObj = item
          this.$nextTick(() => {
            this.isLogShow = true
            this.$refs.morelicense.open()
          })
        }
      }
    },
}
